export default {
    "de": {
        "header": {
            "fortras": "Fortras",
            "overview": "Übersicht"
        },
        "page": {
            "fortras": {
                "open": "Öffnen",
                "load_order": "Bestellung laden",
                "edit_order": "Bestellung bearbeiten",
                "next_order": "Nächste Bestellung",
                "order_number": "Bestellnummer",
                "back": "Zurück",
                "ship_to_address": "Versandaddresse",
                "ship_from_address": "Absenderaddresse",
                "sign_nr": "Zeichen / Nr",
                "quantity": "Anzahl",
                "vp": "Verpackung",
                "content": "Inhalt",
                "unit_kg": "kg",
                "name1": "Name1",
                "name2": "Name2",
                "name3": "Name3",
                "street": "Straße",
                "country": "Land",
                "plz": "PLZ",
                "city": "Ort",
                "text_key": "Hinweis-Schlüssel",
                "phone": "Telefonnummer",
                "length": "Länge",
                "width": "Breite",
                "height": "Höhe",
                "add": "Hinzufügen",
                "cancel": "Abbrechen",
                "ok": "OK",
                "ordered_at": "Auftragsdatum",
                "loading_at": "Beladedatum",
                "loading_at_to": "Beladen von",
                "loading_at_from": "Beladen bis",
                "postages": "Frankatur",
                "direct": "Direktverkehr",
                "please_wait": "Bitte warten Sie einen moment."
            }
        }
    }
}
